<div class="qa-canvas-options">
  <label class="bgcolor-label" for="bgcolor">{{_(KEYS.EDITOR.BACKGROUND_COLOR)}}</label>
  <input
    class="bgcolor-input form-control" id="bgcolor"
    [colorPicker]="question.options.bgColor"
    (colorPickerChange)="question.options.bgColor=$event"
    [style.background]="question.options.bgColor"
    [value]="question.options.bgColor"
    [cpPosition]="'bottom'"
    [cpOKButtonClass]="'btn btn-primary'"
    [cpSaveClickOutside]="true"
    [cpOKButton]="true"
  />

  <label class="drawcolor-label" for="drawcolor">{{_(KEYS.EDITOR.PEN_COLOR)}}</label>
  <input
    class="drawcolor-input form-control" id="drawcolor"
    [colorPicker]="question.options.drawColor"
    (colorPickerChange)="question.options.drawColor=$event"
    [style.background]="question.options.drawColor"
    [value]="question.options.drawColor"
    [cpPosition]="'bottom'"
    [cpOKButtonClass]="'btn btn-primary'"
    [cpSaveClickOutside]="true"
    [cpOKButton]="true"
  />

  <label class="height-label" for="height">{{_(KEYS.EDITOR.HEIGHT)}}</label>
  <input
    class="height-input form-control"
    id="height"
    type="number"
    [(ngModel)]="question.options.height"
  />

  <label class="image-label">{{_(KEYS.EDITOR.BACKGROUND_IMAGE)}}</label>
  <div class="image-input card qa-card-inline-block">
    <div class="card-footer">
      <div class="btn-toolbar justify-content-between">
        <div class="justify-content-between">
          <label class="btn btn-primary qa-no-margin" (click)="onOpenMediaCenterModal()">
            <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_IMAGE)}}
          </label>
        </div>
        <button
          class="btn btn-danger"
          (click)="onDeleteImage()"
          [attr.disabled]="!(question.options.bgImage && question.options.bgImage[locale])? true: null">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
      <img
        class="card-img-top qa-canvas-image mb-3"
        *ngIf="question.options.bgImage && question.options.bgImage[locale]; else qaCanvasImgPlaceholder"
        [src]="question.options.bgImage[locale]"
        (click)="onOpenMediaCenterModal()" />
      <ng-template #qaCanvasImgPlaceholder>
        <img
          class="card-img-top qa-canvas-image mb-3"
          src="/assets/images/placeholder.png"
          (click)="onOpenMediaCenterModal()"/>
      </ng-template>
    </div>
  </div>

</div>

<div class="qa-image-display-options mt-3">
  <label class="qa-image-display-options-title">
    <i class="fa fa-file-pdf-o mr-1"></i>{{_(KEYS.EDITOR.IMAGE_DISPLAY_OPTIONS)}}
  </label>
  <div class="image-config-row">
    <div class="image-config-field">
      <label>{{_(KEYS.EDITOR.IMAGE_WIDTH_PERCENT)}}:</label>
      <input
        class="form-control width-input"
        type="number"
        min="1" max="100"
        [disabled]="!!question.options.fullWidth"
        [ngModel]="question.options.widthPercent ? question.options.widthPercent : null"
        (ngModelChange)="onWidthPercentChange($event)"
      >
    </div>

    <div class="image-config-field">
      <label>{{_(KEYS.EDITOR.CHART_ALIGNMENT)}}:</label>
      <select
        class="form-control"
        [ngModel]="question.options.alignment || 'left'"
        (ngModelChange)="onAlignmentChange($event)"
      >
        <option
          *ngFor="let opt of alignmentOptions"
          [value]="opt.value"
        >
          {{_(KEYS.EDITOR[opt.label])}}
        </option>
      </select>
    </div>

    <div class="image-config-field full-width-field">
      <label>
        <input
          type="checkbox"
          [ngModel]="!!question.options.fullWidth"
          (ngModelChange)="onFullWidthChange($event)"
        >
        {{_(KEYS.EDITOR.IMAGE_FULL_WIDTH)}}
      </label>
    </div>

    <app-qa-image-display-preview
      class="image-config-preview"
      [widthPercent]="question.options.widthPercent"
      [alignment]="question.options.alignment || 'left'"
      [fullWidth]="!!question.options.fullWidth"
    ></app-qa-image-display-preview>
  </div>
</div>
